// Shape geometry shared by the editor preview (canvas clip path) and mirrored by the server
// export mask (backend timeline_compositor._draw_shape_mask). Keeping the two in lock-step is
// what makes "what you see is what you export" true for video/image shapes.

export const SHAPE_TYPES = [
  { id: "rect", label: "Rectangle" },
  { id: "rounded", label: "Rounded" },
  { id: "circle", label: "Circle" },
  { id: "oval", label: "Oval" },
  { id: "square", label: "Square" },
  { id: "pill", label: "Pill" },
  { id: "hexagon", label: "Hexagon" },
  { id: "diamond", label: "Diamond" },
  { id: "triangle", label: "Triangle" },
];

// Trace the shape path centered at (0,0) spanning a w×h box into ctx. Caller wraps with
// save()/translate(cx,cy)/clip()/restore().
export function traceShape(ctx, w, h, shape, cornerRadius = 0) {
  const hw = w / 2, hh = h / 2;
  ctx.beginPath();
  if (shape === "circle" || shape === "oval") {
    ctx.ellipse(0, 0, hw, hh, 0, 0, Math.PI * 2);
  } else if (shape === "pill") {
    const r = Math.min(w, h) / 2;
    if (ctx.roundRect) ctx.roundRect(-hw, -hh, w, h, r); else ctx.rect(-hw, -hh, w, h);
  } else if (shape === "hexagon") {
    const pts = [[-w * 0.25, -hh], [w * 0.25, -hh], [hw, 0], [w * 0.25, hh], [-w * 0.25, hh], [-hw, 0]];
    pts.forEach(([x, y], i) => (i ? ctx.lineTo(x, y) : ctx.moveTo(x, y)));
    ctx.closePath();
  } else if (shape === "diamond") {
    ctx.moveTo(0, -hh); ctx.lineTo(hw, 0); ctx.lineTo(0, hh); ctx.lineTo(-hw, 0); ctx.closePath();
  } else if (shape === "triangle") {
    ctx.moveTo(0, -hh); ctx.lineTo(hw, hh); ctx.lineTo(-hw, hh); ctx.closePath();
  } else if (shape === "rounded" || (cornerRadius || 0) > 0) {
    const r = Math.min(w, h) * Math.min(0.5, cornerRadius || 0.12);
    if (ctx.roundRect) ctx.roundRect(-hw, -hh, w, h, r); else ctx.rect(-hw, -hh, w, h);
  } else {
    ctx.rect(-hw, -hh, w, h);
  }
}

// True when a video/image clip is shaped or repositioned away from a plain full-frame rectangle.
export function isShaped(o) {
  if (!o) return false;
  const s = o.shape;
  if (s && s !== "rect") return true;
  const n = (v, d) => Math.abs((v == null ? d : v) - d) > 1e-3;
  return n(o.shapeW, 1) || n(o.shapeH, 1) || n(o.shapeX, 0.5) || n(o.shapeY, 0.5)
    || n(o.mScale, 1) || n(o.mX, 0) || n(o.mY, 0) || n(o.rotation, 0);
}

// The project's Background Canvas object, or null.
export function backgroundObject(mediaTracks) {
  const tr = (mediaTracks || []).find((t) => t.type === "background");
  return tr && (tr.objects || [])[0] ? tr.objects[0] : null;
}

export function DEFAULT_VIDEO_SHAPE() {
  return { shape: "rect", shapeW: 1, shapeH: 1, shapeX: 0.5, shapeY: 0.5, mScale: 1, mX: 0, mY: 0, mFit: "cover", rotation: 0, cornerRadius: 0.12 };
}
